import { Container } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { useIdNota } from './hooks/useIdNota'
import { MenuButtons } from './components/MenuButtons'
import { Loading } from './components/Loading'
import { ErrorState } from './components/ErrorState'

export function IdNota() {
  const { isLoading, isError, navigate, options } = useIdNota()

  if (isLoading) {
    return <Loading />
  }

  if (isError) {
    return <ErrorState onRetry={() => navigate('/status-pedido')} />
  }

  return (
    <div>
      <HeadingPages name={'CONTROLE DE PRODUÇÃO'} bgColor={'#378bbf'} />
      <Container maxW="container.xl" py={6} my={16}>
        <MenuButtons options={options} />
      </Container>
    </div>
  )
}
